import React, { useState, useEffect } from "react";
import { Button } from "./Button.tsx";
import { useAuth } from "../AuthContext.tsx";

// Update this version when ToS changes
const CURRENT_TOS_VERSION = "2026-02-06";

const ToSNotice: React.FC = () => {
  const { user } = useAuth();
  const [showNotice, setShowNotice] = useState(false);

  useEffect(() => {
    // Only check for logged-in users
    if (user) {
      const acceptedVersion = localStorage.getItem("tos-accepted-version");
      if (acceptedVersion !== CURRENT_TOS_VERSION) {
        setShowNotice(true);
      }
    } else {
      setShowNotice(false);
    }
  }, [user]);

  const handleDismiss = () => {
    localStorage.setItem("tos-accepted-version", CURRENT_TOS_VERSION);
    setShowNotice(false);
  };

  if (!showNotice) {
    return null;
  }

  return (
    <div className="fixed top-20 right-4 bg-white border border-gray-300 shadow-lg rounded-lg p-4 z-40 max-w-sm">
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0">
          <svg
            className="w-5 h-5 text-blue-500"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fillRule="evenodd"
              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
              clipRule="evenodd"
            />
          </svg>
        </div>
        <div className="flex-1">
          <h3 className="text-sm font-semibold text-gray-800 mb-1">
            Updated Terms of Service
          </h3>
          <p className="text-xs text-gray-600 mb-3">
            We've updated our Terms of Service. Please review the changes.
          </p>
          <div className="flex flex-row items-center gap-2 justify-between">
            <a
              href="/terms"
              className="text-xs text-blue-600 hover:text-blue-700 font-medium"
            >
              View Terms
            </a>
            <Button
              variant="primary"
              onClick={handleDismiss}
              className="text-xs py-1 px-3"
            >
              Dismiss
            </Button>
          </div>
        </div>
        <button
          onClick={handleDismiss}
          className="flex-shrink-0 text-gray-400 hover:text-gray-600"
          aria-label="Close"
        >
          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
            <path
              fillRule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export { ToSNotice };
